import { Box, Button } from '@mui/material';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { useApplicationContext } from '../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { useChatContext } from '../../../../../../../../contexts/chat/chat.context';
import { ChatStateWithOptionalId } from '../../../../../../../../contexts/chat/hooks/useChats/reducer/chatListReducer.types';
import { ChatBrandStore, ChatType } from '../../../../../../../../types/chat.types';

const CreateNewChatFooter = () => {
  const { translate } = useTranslation();
  const { selectedGroupOfRooms, onClickOpenPrivateChat } = useChatContext();
  const { onClickCreateChat } = useChatContext();
  const { state } = useApplicationContext();

  const getChat = (storeInfo: ChatBrandStore): ChatStateWithOptionalId => {
    const { id, commercialName, logoUrl } = storeInfo;
    const store: ChatBrandStore = { commercialName, logoUrl, id };
    const brand: ChatBrandStore = {
      commercialName: state.user?.brand?.name as string,
      logoUrl: state.user?.brand?.logoUrl,
      id: state.user?.brand?.id as string,
    };
    return {
      brand,
      title: '',
      stores: [store],
      wasRemoved: false,
      createdAt: new Date(),
      updatedAt: new Date(),
      type: ChatType.PRIVATE,
    };
  };

  const handleCreateChat = () => {
    if (selectedGroupOfRooms?.storeInfo?.id) {
      const chat = getChat(selectedGroupOfRooms.storeInfo);
      onClickOpenPrivateChat(chat);
      return;
    }

    onClickCreateChat();
  };

  return (
    <Box
      sx={{
        px: '20px',
        py: '16px',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        boxSizing: 'border-box',
      }}
    >
      <Button size="small" color="primary" variant="contained" onClick={handleCreateChat}>
        + {translate(LangEnum.GLOBAL_NEW_CHAT)}
      </Button>
    </Box>
  );
};

export default CreateNewChatFooter;
